'use client'

import React, { useEffect, useRef, useState } from "react";
import { Navbar, NavbarBrand, NavbarMenuToggle, NavbarMenuItem, NavbarMenu, NavbarContent, NavbarItem, Dropdown, DropdownMenu, DropdownItem, DropdownTrigger, Button } from "@heroui/react";
import { Typography } from "@mui/material";
import Link from 'next/link';

export default function NavBar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const closeTimer = useRef(null);

  useEffect(() => () => clearTimeout(closeTimer.current), []);

  const openDropdown = () => {
    clearTimeout(closeTimer.current);
    setDropdownOpen(true);
  }
  const closeDropdown = () => {
    // Trigger und Menü liegen durch das Portal in getrennten Hover-Flächen.
    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => setDropdownOpen(false), 200);
  }

  return (

    <Navbar className="bg-background-opaq navbar text-navigation-text" isBlurred isMenuOpen={isMenuOpen} onMenuOpenChange={setIsMenuOpen} maxWidth="full" style={{ zIndex: '1001' }}>
      <NavbarBrand>
        <Link href="/" className="font-bold text-inherit brandtext" size="lg">
          Marlene Gujan Architektur AG
        </Link>
      </NavbarBrand>

      <NavbarContent className="hidden md:flex gap-4" justify="center">
      </NavbarContent>
      <NavbarContent className="hidden md:flex gap-4" justify="end">
        <NavbarItem>
          <Link href="/projekte" size="lg" className="font-bold ">
            Projekte
          </Link>
        </NavbarItem>
        <NavbarItem>
          <Link href="/werkliste" size="lg" className="font-bold">
            Werkliste
          </Link>
        </NavbarItem>
        <NavbarItem onMouseEnter={openDropdown} onMouseLeave={closeDropdown}>
          <Dropdown
            isOpen={isDropdownOpen}
            onOpenChange={(open) => {
              clearTimeout(closeTimer.current);
              setDropdownOpen(open);
            }}
            isNonModal
            shouldBlockScroll={false}
            disableAnimation
            style={{ zIndex: 1002 }}
          >
            <DropdownTrigger>
              <Button className="font-bold navbarbutton">
                Büro
              </Button>
            </DropdownTrigger>
            <DropdownMenu onMouseEnter={openDropdown} onMouseLeave={closeDropdown} onAction={() => setDropdownOpen(false)} className="bg-background-opaq dropdown-navigation custom-dropdown-menu" aria-label="Büro Menu">
              {[
                ['philosophie', 'Philosophie'], ['team', 'Team'], ['portrait', 'Portrait'],
                ['auszeichnungen', 'Auszeichnungen'], ['publikationen', 'Publikationen'],
              ].map(([pfad, titel]) => (
                <DropdownItem key={pfad} as={Link} href={`/buero/${pfad}`} textValue={titel}
                  className="font-bold text-navigation-text" classNames={{ title: 'text-base' }}>
                  {titel}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </NavbarItem>
        <NavbarItem>
          <Link href="/kontakt" className="font-bold" size="lg">
            Kontakt
          </Link>
        </NavbarItem>
      </NavbarContent>

      <NavbarContent className="md:hidden" justify="end">
        <NavbarMenuToggle aria-label={isMenuOpen ? "Close menu" : "Open menu"} />
      </NavbarContent>

      <NavbarMenu onClick={(event) => {
        if (event.target.closest('a')) setIsMenuOpen(false);
      }} className="bg-background-opaq" style={{ marginTop: '1rem', paddingTop: '2.5rem', zIndex: '1001' }}>
        <NavbarMenuItem className="mobile-nav-item">
          <Typography color="primary">
            <Link color="foreground" href="/projekte" className="font-bold block w-full" size="lg">
              Projekte
            </Link>
          </Typography>
        </NavbarMenuItem>
        <NavbarMenuItem className="mobile-nav-item">
          <Typography color="primary">
            <Link color="foreground" href="/werkliste" className="font-bold block w-full" size="lg">
              Werkliste
            </Link>
          </Typography>
        </NavbarMenuItem>
        <NavbarMenuItem className="mobile-nav-item">
          <Typography color="primary">
            <Link color="foreground" href="/buero/philosophie" className="font-bold block w-full" size="lg">
              Philosophie
            </Link>
          </Typography>
        </NavbarMenuItem>
        <NavbarMenuItem className="mobile-nav-item">
          <Typography color="primary">
            <Link color="foreground" href="/buero/team" className="font-bold block w-full" size="lg">
              Team
            </Link>
          </Typography>
        </NavbarMenuItem>
        <NavbarMenuItem className="mobile-nav-item">
          <Typography color="primary">
            <Link color="foreground" href="/buero/portrait" className="font-bold block w-full" size="lg">
              Portrait
            </Link>
          </Typography>
        </NavbarMenuItem>
        <NavbarMenuItem className="mobile-nav-item">
          <Typography color="primary">
            <Link color="foreground" href="/buero/auszeichnungen" className="font-bold block w-full" size="lg">
              Auszeichnungen
            </Link>
          </Typography>
        </NavbarMenuItem>
        <NavbarMenuItem className="mobile-nav-item">
          <Typography color="primary">
            <Link color="foreground" href="/buero/publikationen" className="font-bold block w-full" size="lg">
              Publikationen
            </Link>
          </Typography>
        </NavbarMenuItem>
        <NavbarMenuItem className="mobile-nav-item">
          <Typography color="primary">
            <Link color="foreground" href="/kontakt" className="font-bold block w-full" size="lg">
              Kontakt
            </Link>
          </Typography>
        </NavbarMenuItem>
      </NavbarMenu>
    </Navbar>
  );
}
